import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/observable';
import { EnvironmentSettings } from '../models/environmentsettings.model';

@Injectable()
export class ColorService {
  environmentSettings: EnvironmentSettings;
  constructor(private _http: HttpClient) {
    this.environmentSettings = new EnvironmentSettings();
  }
  public canMoveFromColorComponent;
  getAllColors(): Observable<any> {
    return this._http.get(this.environmentSettings.apiEndPoint + 'api/Color/getallcolors');
  }
  existingRecord(code:any): Observable<any> {
    return this._http.post(this.environmentSettings.apiEndPoint + 'api/Color/ExistingColorCode', code );
  }
  addColorForm(colorFormData:any): Observable<any> {
   
    
    return this._http.post(this.environmentSettings.apiEndPoint + 'api/Color/CreateColor', colorFormData);
   
  }
  updateColorForm(colorFormData: any): Observable<any> {


    return this._http.post(this.environmentSettings.apiEndPoint + 'api/Color/UpdateColor', colorFormData);

  }
  deleteColor(id: number): Observable<any> {
    return this._http.post(this.environmentSettings.apiEndPoint + 'api/Color/DeleteColor',id);
  }
}



// WEBPACK FOOTER //
// ./src/opc/shared/services/color.service.ts